export const defaultBanners = [
  {
    created: 1679030076000,
    id: 999990,
    image:
      "https://up-meraki-public-c0.s3.ap-southeast-1.amazonaws.com/onboarding/Banner_web_1.jpg",
    img_type: "web_banner",
    markups: "",
    supported_languages: "en",
  },
  {
    created: 1690357018000,
    id: 999991,
    image:
      "https://up-meraki-public-c0.s3.ap-southeast-1.amazonaws.com/onboarding/Banner_web_2.jpg",
    img_type: "web_banner",
    markups: "",
    supported_languages: "en",
  },
  {
    created: 1694471353000,
    id: 999992,
    image:
      "https://up-meraki-public-c0.s3.ap-southeast-1.amazonaws.com/onboarding/Banner_web_3.jpg",
    img_type: "web_banner",
    markups: "",
    supported_languages: "en",
  },
  {
    created: 1703233618000,
    id: 999993,
    image:
      "https://up-meraki-public-c0.s3.ap-southeast-1.amazonaws.com/onboarding/Banner_mobile_1.jpg",
    img_type: "mobile_web_banner",
    markups: "",
    supported_languages: "en",
  },
  {
    created: 1730131703000,
    id: 999994,
    image:
      "https://up-meraki-public-c0.s3.ap-southeast-1.amazonaws.com/onboarding/Banner_mobile_2.jpg",
    img_type: "mobile_web_banner",
    markups: "",
    supported_languages: "en",
  },
  {
    created: 1730131703001,
    id: 999995,
    image:
      "https://up-meraki-public-c0.s3.ap-southeast-1.amazonaws.com/onboarding/Banner_mobile_3.jpg",
    img_type: "mobile_web_banner",
    markups: "",
    supported_languages: "en",
  },
];
